module.exports = __webpack_public_path__ + "public/img/ellipse.c424e924.svg";